import { render, staticRenderFns } from "./to-do-template.vue?vue&type=template&id=5a3b5d06&scoped=true"
import script from "./to-do-template.vue?vue&type=script&lang=js"
export * from "./to-do-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3b5d06",
  null
  
)

export default component.exports